<h2 class="wizard_step-title text--title-bold">{{ 'networkAndTechnicalDetails' | translate | titlecase }}</h2>

<form *ngIf="form" [formGroup]="form" (ngSubmit)="onNext()" autocomplete="off">
  <app-input-wrapper
    [control]="form.get('hotspot_enabled')"
    label="{{ 'hotspotEnabled' | translate }}">
    <mat-select
      class="form_control"
      formControlName="hotspot_enabled"
      disableOptionCentering
      panelClass="dropdown"
      name="hotspot_enabled"
      aria-label="{{ 'hotspotEnabled' | translate }}">
      <mat-option [value]="true">{{ 'yes' | translate | titlecase }}</mat-option>
      <mat-option [value]="false">{{ 'no' | translate | titlecase }}</mat-option>
    </mat-select>
  </app-input-wrapper>

  <div *ngIf="isHotspotEnabled" class="phone-os-section">
    <label class="phone-os-section_label">{{ 'patientPhoneOs' | translate }}</label>
    <div class="os-toggle">
      <button
        *ngFor="let os of phoneOptions"
        type="button"
        class="os-toggle_option"
        [ngClass]="{ 'os-toggle_option--active': form.get('phone_os').value === os }"
        (click)="setPhoneOs(os)">
        {{ os }}
      </button>
    </div>
  </div>

  <app-input-wrapper
    [control]="form.get('wifi_network_name')"
    label="{{ 'homeWifiSsid' | translate }}"
    identifier="wifi_network_name">
    <input
      class="form_control"
      type="text"
      formControlName="wifi_network_name"
      name="wifi_network_name"
      id="wifi_network_name"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="none"
      spellcheck="false"
      data-lpignore="true"
      data-1p-ignore="true">
  </app-input-wrapper>

  <!-- Plain-text input with a non-credential control name so the browser does
       not treat it as a password field and offers no autofill / save prompt;
       the WiFi password stays visible as requested. -->
  <app-input-wrapper
    [control]="form.get('wifi_network_key')"
    label="{{ 'homeWifiPassword' | translate }}"
    identifier="wifi_network_key">
    <input
      class="form_control"
      type="text"
      formControlName="wifi_network_key"
      name="wifi_network_key"
      id="wifi_network_key"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="none"
      spellcheck="false"
      data-lpignore="true"
      data-1p-ignore="true">
  </app-input-wrapper>

  <div class="wizard_footer">
    <button class="button button--secondary" type="button" (click)="back.emit()">
      <span class="regular">{{ 'back' | translate }}</span>
    </button>
    <button class="button button--primary" type="submit" [disabled]="!canProceed">
      <span class="regular">{{ 'next' | translate }}</span>
    </button>
  </div>
</form>
